import DraggableButton from 'components/common/draggable-button/DraggableButton';
import { DraggableProvided } from 'react-beautiful-dnd';
import { TextType } from 'types/common/text';
import { ICON } from 'constants/icons';
import { CustomBoard } from 'types/feature/menu/customBoard';
import { DISPLAY_TYPE } from 'data/display';
import DisplayStatusBadge from 'components/common/badge/display-status/DisplayStatusBadge';

type MenuContentRowsProps = {
  provided: DraggableProvided;
  board: CustomBoard;
  moveToBoardDetail: (boardId: string) => void;
  onClickDelete: (e: React.MouseEvent<HTMLElement>, customBoardId: string) => void;
  index: number;
};

const MenuContentRows = ({
  provided,
  moveToBoardDetail,
  onClickDelete,
  board,
  index,
}: MenuContentRowsProps) => {
  return (
    <>
      <tr
        {...provided.draggableProps}
        ref={provided.innerRef}
        onClick={moveToBoardDetail.bind(this, board.id)}
        key={board.id}
        className='w-full border-b h-[52px] cursor-pointer'
      >
        <td {...provided.dragHandleProps}>
          <div className='flex items-center justify-center'>
            {' '}
            <DraggableButton />
          </div>
        </td>
        {/* No. */}
        <td className='text-sm text-center font-h3 text-gray-99 px-2.5'>{index + 1}</td>

        {/* 타이틀 */}
        <td className={`${TextType.h4} text-gray-44 px-2.5`}>{board.title.ko}</td>

        {/* 노출유형 */}
        <td className={`${TextType.body1} text-gray-44 px-2.5 text-center`}>{DISPLAY_TYPE[board.displayType]}</td>

        {/* 기간 */}
        <td className={`px-2.5 text-center`}>
          <div className={`${TextType.body1} text-gray-44`}>
            <span className='text-inherit'>{board.startDate}</span>-
            {board.displayType === 'ALWAYS_ON' ? (
              <span className='text-inherit'>종료시</span>
            ) : (
              <span className='text-inherit'>{board.endDate}</span>
            )}
          </div>
        </td>

        {/* 진행상태 */}
        <td className={`${TextType.body1} text-gray-44 px-2.5 text-center`}>
          {<DisplayStatusBadge status={board.displayStatus ?? 'NONE'} />}
        </td>

        {/* 삭제 */}
        <td className={`${TextType.body1} text-gray-44 px-2.5 text-center`}>
          <button onClick={e => onClickDelete(e, board.id)} className='flex items-center justify-center w-full h-full'>
            <img className='h-[18px]' alt='삭제' src={ICON.DELETE_BUTTON} />
          </button>
        </td>
      </tr>
    </>
  );
};

export default MenuContentRows;
